'use strict';

var assign = require('lodash.assign');

module.exports = function (parts) {
  return assign.apply(null, parts);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/lib/last-search-cookie/merge-objects.js
 ** module id = 459
 ** module chunks = 0
 **/